import React from 'react';
import {
  Col,
  Grid,
  Row,
} from 'react-bootstrap';
import createLoginLink from './createLoginLink.js';
import Panel from '../Panel.jsx';

const BadTokenMessage = () => (
  <Panel>
    <Grid fluid>
      <Row>
        <Col xs={12}>
          <p style={{fontWeight:'450'}}>
            This link is invalid or expired.
          </p>
        </Col>
      </Row>
    </Grid>
    <a
      href={createLoginLink()}
    >
      Return to login
    </a>
  </Panel>
);

export default BadTokenMessage;
